export const NAME = 'AirportDelayMap';
